
/**
 * Ajoute les attributs à un $element. Le renvoie
 * @param {Element} $element 
 * @param {object} attrs 
 * @returns {Element}
 */
export const setAttributes=($element, attrs) => {
    for(let attrName in attrs){
        switch (attrName) {             
            case 'id':
            case 'className':
                $element[attrName] = attrs[attrName];
                break;
            default:
                $element.setAttribute(attrName, attrs[attrName]);
        }
    }
    return $element;
};